import { render } from "./BasicLoading.vue?vue&type=template&id=5189e042&scoped=true"
const script = {}

import "./BasicLoading.vue?vue&type=style&index=0&id=5189e042&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5189e042"]])

export default __exports__